import { Injectable } from '@angular/core';
import { GeorefApiService } from './georef-api.service';

@Injectable({
	providedIn: 'root',
})
export class PaisService {
	constructor(private _georefApiServices: GeorefApiService) {}

	/* GET */

	get(params: Object = {}, absolutePath = false) {
		return this._georefApiServices.get(`/paises`, params, absolutePath);
	}
}
